<template>
  <MongoDataTable
    ref="table"
    :offline="true"
    :title="title"
    :autoSchema="true"
    :items="items"
    :syncUserState="false"
    :insertable="false"
    :editable="true"
    :readonly="true"
    :deletable="false"
    :selectable="false"
    :refreshable="false"
    :filterable="false"
    :columnSelectable="false"
    :sortable="false"
    :rowsPerPage="-1"
    :countable="false"
    :hideHeaders="false"
    :hideFooters="true"
    :rowClass="rowClass"
    containerClass="elevation-0"
    toolbarClass="pt-0"
    @click:row="props => {/* $emit('click:row', props) */}"
  >
  </MongoDataTable>
</template>

<script>
import MongoDataTable from '../../components/mongo-datatable/MongoDataTable'
// import { FIELD_ID } from '../../libs/mongo-datatable'

export default {
  props: {
    ready: { type: Boolean, required: false, default: true },
    loading: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: null },
    items: { type: Array, required: true },
    selectedId: { type: [String, Number], required: false, default: undefined }
  },
  methods: {
    rowClass ({ index, item }) {
      return [
        'cursor-pointer',
        item['created_at'] === this.selectedId ? this.hilightClass() : undefined
      ]
    },
    hilightClass () {
      return 'yellow lighten-4'
    }
  },
  components: {
    MongoDataTable
  }
}
</script>
